import {
    AccountService,
    AuthService,
    ContactService,
    NotificationService,
    RegistrationService,
    ScheduleService,
    UserService,
    WalletService,
    SupportService,
    XepptClient,
    DocumentService,
    TransactionService,
    GiftCardsService,
    PublicService,
    ApiKeysService,
    OrdersService
} from '@xeppt/xeppt-sdk';
import { PayBillService } from '@xeppt/xeppt-sdk/services/paybill';

export const sdk = new XepptClient(
    {
        baseURL: process.env.REACT_APP_BACKEND_URL
    },
    () => {
        localStorage.removeItem('client-metadata');
    }
);

export const apiRegistrationService = new RegistrationService(sdk);
export const apiAuthService = new AuthService(sdk);
export const apiUserService = new UserService(sdk);
export const apiWalletService = new WalletService(sdk);
export const apiAccountService = new AccountService(sdk);
export const apiScheduleService = new ScheduleService(sdk);
export const apiPayBillService = new PayBillService(sdk);
export const apiNotificationService = new NotificationService(sdk);
export const apiContactService = new ContactService(sdk);
export const apiSupportService = new SupportService(sdk);
export const apiDocumentService = new DocumentService(sdk);
export const apiTransactionsService = new TransactionService(sdk);
export const apiGiftCardsService = new GiftCardsService(sdk);
export const apiPublicService = new PublicService(sdk);
export const apiApiKeysService = new ApiKeysService(sdk);
export const apiOrderService = new OrdersService(sdk);

// Local (non-SDK) services are re-exported here so consumers import them from
// the '@api' barrel like every other service. Bare '@api' maps to this index
// file, so '@api/connect_service' subpath imports do not resolve under webpack.
export { apiConnectService, ConnectApiError } from './connect_service';
export type { ConnectSession, ConnectChargeResult } from './connect_service';

// Sandbox-only connect service — in-memory auth, never touches client-metadata.
export { sandboxConnectService } from './sandbox_connect_service';
export type { SandboxLoginResult } from './sandbox_connect_service';

export { apiSandboxService, SandboxApiError } from './sandbox_service';
export type {
    SandboxSessionRequest,
    SandboxSessionResponse,
    SandboxExecRequest,
    SandboxExecResponse
} from './sandbox_service';

export { apiWebhookService, WebhookApiError } from './webhook_service';
export type {
    WebhookEnvironment,
    WebhookEndpointItem,
    CreateWebhookEndpointRequest,
    CreateWebhookEndpointResponse,
    RotateWebhookSecretResponse,
    ListWebhookEndpointsResponse,
    WebhookDeliverySummary,
    ListWebhookDeliveriesOutput,
    GetWebhookDeliveryOutput,
    WebhookEndpointDeliveryStats,
    GetWebhookDeliveryStatsOutput,
    WebhookEventType,
    ListWebhookEventTypesOutput
} from './webhook_service';

export { apiPayoutService, PayoutApiError } from './payout_service';
export type {
    Payout,
    PayoutStatus,
    ListPayoutsResponse,
    ListPayoutsParams
} from './payout_service';

export { apiMerchantConfigService, MerchantConfigApiError } from './merchant_config_service';
export type {
    MerchantConfig,
    MerchantConfigPatch
} from './merchant_config_service';

export {
    apiKeyService,
    ApiKeyApiError,
    describeScopes,
    scopesForLevel,
    SCOPE_FULL_ACCESS,
    READ_ONLY_SCOPES
} from './api_key_service';
export type { PermissionLevel, CreateApiKeyResult, ApiKeyInfo } from './api_key_service';

export { apiRefundService, RefundApiError } from './refund_service';
export type {
    RefundQuote,
    RefundLimits,
    RefundLimitPeriod,
    RefundRequest,
    RefundResult
} from './refund_service';

export { apiOrderBlockService, OrderBlockApiError } from './order_block_service';

export {
    apiTransactionsBusinessService,
    TransactionsBusinessApiError
} from './transactions_business_service';
export type {
    ListTransactionsBusinessParams,
    ListTransactionsBusinessResponse
} from './transactions_business_service';

export { apiHomeSummaryService, HomeSummaryApiError } from './home_summary_service';
export type {
    HomeSummary,
    HomeSummaryPeriodStats,
    HomeSummaryDailyVolume
} from './home_summary_service';
